import './ExportModal.scss';

import { useExport } from "../hooks/useExport";

import FileDownload from "@mui/icons-material/FileDownload";

import { Button } from "../common-components/Buttons/Buttons";

const ExportModal = () => {
    const { handleExport } = useExport({componentId: "departures"});

    return (
        <div className={"export-modal"}>
            <div className={"export-modal_container"}>
                <div className={"export-modal_icon"}>
                    <FileDownload style={{fontSize: "60px"}}/>
                </div>
                <div className={"export-modal_title"}>
                    {"Экспорт в Excel"}
                </div>
                <div className={"export-modal_button"}>
                    <Button Icon={FileDownload} title={"Экспорт"} onClick={handleExport}/>
                </div>
            </div>
        </div>
    )
}

export default ExportModal;